// @flow

import * as React from 'react';

/** A very basic convenience component that wraps React elements with <li> tags */

type Props = {|
  children: React.Node,
|};

const ListTemplate = ({ children }: Props) =>
  React.Children.map(children, child => <li>{child}</li>);

export default ListTemplate;
